import React from 'react'
import { Typography } from '../primitives/index.js'
import { MenuItem } from '../primitives/index.js'

export const NoSuggestions = () => (
  <MenuItem disabled={true}>
    <Typography variant="caption">No suggestions</Typography>
  </MenuItem>
)
